// Optimizer + Saved Strategies API clients
import axios from "axios";
import { API } from "./api";

const client = axios.create({ baseURL: API, timeout: 30000, withCredentials: true });

export const runOptimizer = (payload) =>
  client.post(`/forge/optimize`, payload).then((r) => r.data);

export const listSavedStrategies = () =>
  client.get(`/saved-strategies`).then((r) => r.data);

export const saveStrategy = (payload) =>
  client.post(`/saved-strategies`, payload).then((r) => r.data);

export const deleteSavedStrategy = (id) =>
  client.delete(`/saved-strategies/${id}`).then((r) => r.data);

export const markSavedStrategy = (id) =>
  client.post(`/saved-strategies/${id}/mark`).then((r) => r.data);
